
import HolidaysModel from "../../model/holidays.model";
import ApiServices from "../../services/api.service";
import "./holidays.scss";
import React, { useState } from 'react';
import Moment from "react-moment";
import ADD_BUTTON_IMG from "../../assets/images/add-button.png"
import CALENDAR_IMG from "../../assets/images/calendar.png"
import AddHolidaysModal from "../modal/add-holiday";
import ProfileModel from "../../model/profile.model";
import { getAuth } from "firebase/auth";
import config from "../../config";
import tokenService from "../../services/token.service";
import moment from "moment";
import JSON_HOLIDAY from "../../assets/json/holiday-2024.json";
import { Button, Spinner } from 'react-bootstrap';

const HolidaysComponent = ({ profileRes }: any) => {
    const profile: ProfileModel = profileRes
    const user = tokenService.getUser();
    const [holidayList, setHolidayList] = useState<HolidaysModel[]>();
    const [showAddHoliday, setShowAddHoliday] = useState(false);
    const [syncingHolidays, setSyncingHolidays] = useState<{ [key: number]: boolean }>({});
    const [syncedHolidays, setSyncedHolidays] = useState<{ [key: number]: boolean }>({});

    const loadHolidays = () => {
        ApiServices().getHolidays().then((res) => {
            const querySnapshot = res;
            let hdList: HolidaysModel[] = [];
            querySnapshot.forEach((doc) => {
                const dataRes = doc.data() as HolidaysModel;
                hdList.push(dataRes);
            });
            console.log(hdList);
            setHolidayList(hdList);
        })
    }

    const syncHolidayToCalendar = async(item: HolidaysModel, index: number) => {
        const auth = getAuth();
        if (!auth || !user?.accessToken) {
            alert('กรุณา login ใหม่เพื่อ sync calendar');
            return;
        }

        // Set syncing state
        setSyncingHolidays(prev => ({ ...prev, [index]: true }));

        try {
            const eventNow = {
                'summary': "วันหยุด : " + item.title,
                'description':
                    "<b>รายละเอียด</b>" + "<ul><li>เนื่องในวัน : " + item.title + " </li>" + "</ul>",
                'start': {
                    'date': moment(item.date.toDate()).format("YYYY-MM-DD"),
                    'timeZone': 'Asia/Bangkok',
                },
                'end': {
                    'date': moment(item.date.toDate()).add(1,'days').format("YYYY-MM-DD"),
                    'timeZone': 'Asia/Bangkok',
                }
            }

            const response = await fetch(config.api.google_apis + config.calendarOfficeHoliday + "/events", {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + user.accessToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(eventNow)
            });

            const data = await response.json();
            
            if (data.id) {
                console.log('✅ Synced to calendar:', data);
                setSyncedHolidays(prev => ({ ...prev, [index]: true }));
                alert(`✅ Sync สำเร็จ: ${item.title}`);
            } else {
                console.error('❌ Sync failed:', data);
                alert(`❌ Sync ไม่สำเร็จ: ${data.error?.message || 'Unknown error'}`);
            }
        } catch (error: any) {
            console.error('❌ Error syncing to calendar:', error);
            alert(`❌ Error: ${error.message || 'Unknown error'}`);
        } finally {
            setSyncingHolidays(prev => ({ ...prev, [index]: false }));
        }
    }

    const addHolidays = () => {
        // setShowAddHoliday(true);
    }

    React.useEffect(() => {
        console.log(profile);
        console.log("1111 : ");
        loadHolidays();
    }, [])

    const isAdmin = profile && profile.email === "benz@scoutout.net";

    return (
        <>
            <div className="container holidays">
                <div className="d-flex holidays-header-control">
                    <span className="holidays-text">All Holidays ({holidayList?.length})</span>
                    {
                        isAdmin ?
                        <img src={ADD_BUTTON_IMG} className="add-holiday-button" onClick={addHolidays}></img> : null
                    }
                </div>

                <div 
                    className="holidays-list"
                    style={isAdmin ? {} : { gridTemplateColumns: '10% 60% 30%' }}
                >
                    <span className="holidays-title">No.</span>
                    <span className="holidays-title">Title.</span>
                    <span className="holidays-title">Date</span>
                    {
                        isAdmin ?
                        <span className="holidays-title">Action</span> : null
                    }
                </div>

                <div className="divider-line"></div>

                {
                    holidayList?.map((item: HolidaysModel, index: number) => {
                        const isSyncing = syncingHolidays[index];
                        const isSynced = syncedHolidays[index];

                        return (
                            <div className="d-flex flex-column holidays-item" key={index}>
                                <div 
                                    className="holidays-list"
                                    style={isAdmin ? {} : { gridTemplateColumns: '10% 60% 30%' }}
                                >
                                    <span className="holidays-desc">{index + 1}</span>
                                    <span className="holidays-desc">{item.title}</span>
                                    <span className="holidays-desc">
                                        <Moment format="DD-MMM-YYYY">
                                            {item.date.toDate()}
                                        </Moment>
                                    </span>
                                    {
                                        isAdmin ?
                                        <div className="holidays-action">
                                            <Button
                                                variant={isSynced ? "success" : "primary"}
                                                size="sm"
                                                onClick={() => syncHolidayToCalendar(item, index)}
                                                disabled={isSyncing}
                                                className="sync-calendar-btn"
                                            >
                                                {isSyncing ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="me-1" />
                                                        Syncing...
                                                    </>
                                                ) : isSynced ? (
                                                    <>✓ Synced</>
                                                ) : (
                                                    <>
                                                        <img src={CALENDAR_IMG} className="sync-icon" alt="sync" />
                                                        Sync Calendar
                                                    </>
                                                )}
                                            </Button>
                                        </div> : null
                                    }
                                </div>
                                <div className="divider-line"></div>
                            </div>
                        )
                    })
                }

                {
                    showAddHoliday && <AddHolidaysModal isShow={true} ></AddHolidaysModal>
                }
            </div>
        </>
    )
}

export default HolidaysComponent;
